import { useState } from "react";

/**
 * Inline help tooltip with "?" icon.
 * Usage: <Tooltip text="Le FEC est le Fichier des Écritures Comptables..." />
 */
export default function Tooltip({ text, position = "top" }) {
  const [open, setOpen] = useState(false);
  return (
    <span
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        marginLeft: 4,
        cursor: "help",
      }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      tabIndex={0}
      data-testid="tooltip-trigger"
    >
      <span style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 16,
        height: 16,
        borderRadius: "50%",
        background: "var(--surface-2, #eee)",
        color: "var(--ink-muted, #666)",
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1,
        userSelect: "none",
      }}>?</span>
      {open && (
        <span
          role="tooltip"
          data-testid="tooltip-content"
          style={{
            position: "absolute",
            zIndex: 1000,
            ...(position === "top"
              ? { bottom: "calc(100% + 6px)", left: "50%", transform: "translateX(-50%)" }
              : { top: "calc(100% + 6px)", left: "50%", transform: "translateX(-50%)" }),
            background: "var(--ink, #0A1D22)",
            color: "var(--cream, #FAF6EE)",
            padding: "8px 12px",
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 400,
            lineHeight: 1.45,
            width: 260,
            maxWidth: "90vw",
            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
            whiteSpace: "normal",
            textAlign: "left",
            pointerEvents: "none",
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
}
